import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';
import TaskPanelHeader from '../_common/TaskPanelHeader';
import TaskPanelBodyAsOwner from '../_common/TaskPanelBodyAsOwner';

// eslint-disable-next-line react/prefer-stateless-function
class TaskInfoBlockAsOwner extends Component {
  render() {
    return (
      <article className="panel task task_detailed panel-default">
        <TaskPanelHeader task={this.props.task} typeLayout={`view`} />
        <TaskPanelBodyAsOwner task={this.props.task} />
        <div className="panel-footer panel-inner-border-top">
          <div className="hor-scroll hor-scroll_always">
            <div className="hor-scroll-wrapper">
              <NavLink
                to={`/my-tasks/view/${this.props.task.id}/executions/${this.props.task.tasksExecsStat.statuses[4].execStatusId}`}
                className="counter"
                data-container="body"
                data-placement="top"
                data-toggle="tooltip-hover"
                href=""
                title=""
                data-original-title={t('Оплаченные выполнения')}
              >
                <div className="counter-val text-success">
                  {this.props.task.tasksExecsStat.statuses[4].execCountByStatus}
                </div>
                <div className="counter-label">{t('Оплачено')}</div>
              </NavLink>
              <NavLink
                to={`/my-tasks/view/${this.props.task.id}/executions/${this.props.task.tasksExecsStat.statuses[2].execStatusId}`}
                className="counter"
                data-container="body"
                data-placement="top"
                data-toggle="tooltip-hover"
                href=""
                title={t('Выполнения на проверке')}
                data-original-title={t('Выполнения на проверке')}
              >
                <div className="counter-val">
                  {this.props.task.tasksExecsStat.statuses[2].execCountByStatus}
                </div>
                <div className="counter-label">{t('На проверке')}</div>
              </NavLink>
              <NavLink
                to={`/my-tasks/view/${this.props.task.id}/executions/${this.props.task.tasksExecsStat.statuses[5].execStatusId}`}
                className="counter"
                data-container="body"
                data-placement="top"
                data-toggle="tooltip-hover"
                href=""
                title=""
                data-original-title={t('Отказанные выполнения')}
              >
                <div className="counter-val text-danger">
                  {this.props.task.tasksExecsStat.statuses[5].execCountByStatus}
                </div>
                <div className="counter-label">{t('Отказано')}</div>
              </NavLink>
              <NavLink
                to={`/my-tasks/view/${this.props.task.id}/reviews/likes`}
                className="counter"
                data-container="body"
                data-placement="top"
                data-toggle="tooltip-hover"
                href=""
                title=""
                data-original-title={t('Положительные отзывы')}
              >
                <div className="counter-val text-muted">
                  {this.props.task.taskCommentsStat.likes}
                </div>
                <div className="counter-label">
                  <i className="fa fa-thumbs-o-up text-info" /> {t('Отзывы')}
                </div>
              </NavLink>
              <NavLink
                to={`/my-tasks/view/${this.props.task.id}/reviews/dislikes`}
                className="counter"
                data-container="body"
                data-placement="top"
                data-toggle="tooltip-hover"
                href=""
                title=""
                data-original-title={t('Отрицательные отзывы')}
              >
                <div className="counter-val text-muted">
                  {this.props.task.taskCommentsStat.dislikes}
                </div>
                <div className="counter-label">
                  <i className="fa fa-thumbs-o-down text-info" /> {t('Отзывы')}
                </div>
              </NavLink>
            </div>
          </div>
        </div>
      </article>
    );
  }
}

TaskInfoBlockAsOwner.propTypes = {
  task: PropTypes.shape({
    id: PropTypes.number.isRequired,
    taskCommentsStat: PropTypes.shape({
      dislikes: PropTypes.number.isRequired,
      likes: PropTypes.number.isRequired,
      neutral: PropTypes.number.isRequired
    }).isRequired,
    tasksExecsStat: PropTypes.shape({
      statuses: PropTypes.shape({}).isRequired
    }).isRequired,
    statFinishedExecs: PropTypes.number.isRequired
  }).isRequired
};

export default withRouter(TaskInfoBlockAsOwner);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskView/TaskInfoBlockAsOwner.js